/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actiontextplaceholder2Inputs */

const en_actiontextplaceholder2 = /** @type {(inputs: Actiontextplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. 2-for-1 cocktails today until 7 pm`)
};

const de_actiontextplaceholder2 = /** @type {(inputs: Actiontextplaceholder2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. Heute 2 für 1 Cocktails bis 19 Uhr`)
};

/**
* | output |
* | --- |
* | "e.g. 2-for-1 cocktails today until 7 pm" |
*
* @param {Actiontextplaceholder2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actiontextplaceholder2 = /** @type {((inputs?: Actiontextplaceholder2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actiontextplaceholder2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actiontextplaceholder2(inputs)
	return de_actiontextplaceholder2(inputs)
});
export { actiontextplaceholder2 as "actionTextPlaceholder" }